import { Component, OnInit, TemplateRef } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/primeng';
import { SearchDate } from '../../../infrastructure/searchDate.helper';
import { Constant } from '../../../infrastructure/constant';
import { TPLService } from '../../../services';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Shipment } from '../../../models';

@Component({
  selector: 'app-list-shipment-to-partner',
  templateUrl: './list-shipment-to-partner.component.html',
  styles: []
})
export class ListShipmentToPartnerComponent implements OnInit {

  parentPage = Constant.pages.shipmentPartnerManagement.name;
  currentPage = Constant.pages.shipmentPartnerManagement.children.listShipmentToPartner.name
  constructor(
    private tplService:TPLService,
    private bsModalService:BsModalService,
    private messageService: MessageService
  ) { }

  fromDate:any = new Date();
  toDate:any =new Date();
  dataSource:any[]=[];
  pageNumber:number = 1;
  pageSize:number = 20;
  totalRecord:number = 0;
  totalRecordDetail:number = 0;
  pageNumberDetail:number = 1;
  pageSizeDetail:number = 20;
  reasonCancel:string;
  bsModalRef: BsModalRef;
  idCancel:string;
  listShipmentDetail:Shipment[]=[];
  ngOnInit() {
  }

  async getListShipmentToPartner(){
    this.dataSource =[];
    let fromDate = SearchDate.formatDateNoTime(this.fromDate);
    let toDate = SearchDate.formatDateNoTime(this.toDate.setDate( this.toDate.getDate() + 1 ));
    const res = await this.tplService.getListOrderAhamove(fromDate,toDate,this.pageSize);
    if(res){
      this.dataSource = res;
      this.totalRecord = res.length;
    }
  }
  onPageChangeLeft(event: LazyLoadEvent) {
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.getListShipmentToPartner();
  }

  showModalCancel(templete: TemplateRef<any>, id:string){
    this.reasonCancel="";
    this.idCancel = id;
    this.bsModalRef = this.bsModalService.show(templete, {
      class: "inmodal bounceInRight modal-sm", backdrop: 'static', keyboard: false
    });
  }

  async confirmCancel(){
    if(!this.reasonCancel){
      this.messageService.add({ severity: Constant.messageStatus.warn
      , detail: 'Vui lòng nhập lý do hủy' });
      return;
    }
    const res = await this.tplService.cancelOrderAhamove(this.idCancel, this.reasonCancel);
    if(res){
      this.messageService.add({ severity: Constant.messageStatus.success, detail: 'Hủy đơn thành công' });
      this.bsModalRef.hide();
      await this.getListShipmentToPartner();
    }
  }

  async showModalView(templete: TemplateRef<any>, id:string){
    this.idCancel = id;
    this.getListShipmentInOrderAhamove();
      this.bsModalRef = this.bsModalService.show(templete, {
        class: "inmodal bounceInRight modal-lg", backdrop: 'static', keyboard: false
      });
  }
  async getListShipmentInOrderAhamove(){
    const res = await this.tplService.getListShipmentInOrderAhamove(this.idCancel,this.pageNumberDetail,this.pageSizeDetail);
    if(res){
      this.listShipmentDetail = res;
      this.totalRecordDetail = res[0].totalRecords;
    }
  }
  onPageChangeDetail(event: LazyLoadEvent) {
    this.pageNumberDetail = event.first / event.rows + 1;
    this.pageSizeDetail = event.rows;
    this.getListShipmentInOrderAhamove();
  }

  loadStatusVN(status:any){
    let stt =""
    switch (status){
      case 'ASSIGNING':{
        stt = "Đang tìm tài xế"
        break;
      }
      case 'ACCEPTED':{
        stt = "Tài xế đã xác nhận"
        break;
      }
      case 'IN PROCESS':{
        stt = "Đang đi lấy hàng"
        break;
      }
      case 'COMPLETED':{
        stt = "Giao thành công"
        break;
      }
      case 'CANCELLED':{
        stt = "Hủy đơn"
        break;
      }
      default:{
        stt = "Đang tìm tài xế"
        break;
      }
    }
    
    return stt;
  }
  loadPaymentVN(method:any){
    let stt =""
    switch (method){
      case 'CASH':{
        stt = "Người gửi thanh toán bằng tiền mặt"
        break;
      }
      case 'BALANCE':{
        stt = "Người gửi thanh toán bằng ví Aha"
        break;
      }
      case 'CASH_BY_RECIPIENT':{
        stt = "Người nhận thanh toán bằng tiền mặt"
        break;
      }
      default:{
        stt = "Người gửi trả Tiền mặt"
        break;
      }
    }
    
    return stt;
  }
  async view(data){
    let link = await this.tplService.getOrderTrackingLink(data._id);
    window.open(link.shared_link, "_blank");
  }
}
